(function () {
  var STORAGE_KEY = 'recently_viewed_products';
  var MAX_STORED_PRODUCTS = 12;
  var MAX_RENDERED_PRODUCTS = 8;

  function safeParse(value, fallback) {
    try {
      return JSON.parse(value);
    } catch (error) {
      return fallback;
    }
  }

  function getStoredProducts() {
    return safeParse(localStorage.getItem(STORAGE_KEY) || '[]', []);
  }

  function setStoredProducts(products) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(products));
  }

  function storeCurrentProduct() {
    var productDataEl = document.getElementById('RecentlyViewedProductData');
    if (!productDataEl) return;

    var productData = safeParse(productDataEl.textContent, null);
    if (!productData || !productData.id) return;

    var existingProducts = getStoredProducts();

    existingProducts = existingProducts.filter(function (item) {
      return String(item.id) !== String(productData.id);
    });

    existingProducts.unshift(productData);

    if (existingProducts.length > MAX_STORED_PRODUCTS) {
      existingProducts = existingProducts.slice(0, MAX_STORED_PRODUCTS);
    }

    setStoredProducts(existingProducts);
  }

  function escapeHtml(str) {
    if (typeof str !== 'string') return '';
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function createCardMarkup(item) {
  var imageMarkup = item.featured_image
    ? '<div class="recently-viewed__image"><img src="' + escapeHtml(item.featured_image) + '" alt="' + escapeHtml(item.title) + '" loading="lazy"></div>'
    : '<div class="recently-viewed__image recently-viewed__image--placeholder"></div>';

  var tags = Array.isArray(item.tags) ? item.tags.map(function (tag) {
    return String(tag).toLowerCase().trim();
  }) : [];

  var isMadeToOrder = tags.indexOf('made-to-order') !== -1;
  var hidePrice = item.hide_price === true || isMadeToOrder;

  var badgeMarkup = isMadeToOrder
    ? '<div class="recently-viewed__badge">Made to order</div>'
    : '';

  var priceMarkup = '';
  if (!hidePrice && item.price) {
    priceMarkup = '<div class="recently-viewed__price">' + escapeHtml(item.price) + '</div>';
  }

  return (
    '<article class="recently-viewed__card">' +
      '<a href="' + escapeHtml(item.url) + '" class="recently-viewed__link">' +
        imageMarkup +
        '<div class="recently-viewed__info">' +
          '<h3 class="recently-viewed__name">' + escapeHtml(item.title) + '</h3>' +
          badgeMarkup +
          priceMarkup +
        '</div>' +
      '</a>' +
    '</article>'
  );
}

  function updateNavigationState(section, viewport) {
    var prevBtn = section.querySelector('[data-recently-viewed-prev]');
    var nextBtn = section.querySelector('[data-recently-viewed-next]');

    if (!prevBtn || !nextBtn) return;

    var maxScrollLeft = viewport.scrollWidth - viewport.clientWidth;
    var canScroll = maxScrollLeft > 4;

    if (!canScroll) {
      prevBtn.setAttribute('disabled', 'disabled');
      nextBtn.setAttribute('disabled', 'disabled');
      section.classList.add('recently-viewed--static');
      return;
    }

    section.classList.remove('recently-viewed--static');

    if (viewport.scrollLeft <= 4) {
      prevBtn.setAttribute('disabled', 'disabled');
    } else {
      prevBtn.removeAttribute('disabled');
    }

    if (viewport.scrollLeft >= maxScrollLeft - 4) {
      nextBtn.setAttribute('disabled', 'disabled');
    } else {
      nextBtn.removeAttribute('disabled');
    }
  }

  function getScrollAmount(section) {
    var card = section.querySelector('.recently-viewed__card');
    var track = section.querySelector('.recently-viewed__track');

    if (!card || !track) return 0;

    var trackStyles = window.getComputedStyle(track);
    var gap = parseFloat(trackStyles.gap || trackStyles.columnGap || 0) || 0;

    return card.offsetWidth + gap;
  }

  function bindSlider(section) {
    var viewport = section.querySelector('[data-recently-viewed-viewport]');
    var prevBtn = section.querySelector('[data-recently-viewed-prev]');
    var nextBtn = section.querySelector('[data-recently-viewed-next]');

    if (!viewport) return;
    if (section.dataset.recentlyViewedBound === 'true') {
      updateNavigationState(section, viewport);
      return;
    }

    section.dataset.recentlyViewedBound = 'true';

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        viewport.scrollBy({
          left: -getScrollAmount(section),
          behavior: 'smooth'
        });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        viewport.scrollBy({
          left: getScrollAmount(section),
          behavior: 'smooth'
        });
      });
    }

    viewport.addEventListener('scroll', function () {
      updateNavigationState(section, viewport);
    });

    window.addEventListener('resize', function () {
      updateNavigationState(section, viewport);
    });

    updateNavigationState(section, viewport);
  }

  function renderRecentlyViewedSection(section) {
    if (!section) return;

    var viewport = section.querySelector('[data-recently-viewed-viewport]');
    var track = section.querySelector('[data-recently-viewed-track]');

    if (!viewport || !track) return;

    var items = getStoredProducts();

    if (window.currentProductHandle) {
      items = items.filter(function (item) {
        return item.handle !== window.currentProductHandle;
      });
    }

    if (!items.length) {
      section.style.display = 'none';
      return;
    }

    items = items.slice(0, MAX_RENDERED_PRODUCTS);

    track.innerHTML = items.map(createCardMarkup).join('');
    section.style.display = '';

    bindSlider(section);
  }

  function initRecentlyViewed() {
    storeCurrentProduct();

    var sections = document.querySelectorAll('[data-recently-viewed-section]');
    sections.forEach(function (section) {
      renderRecentlyViewedSection(section);
    });
  }

  document.addEventListener('DOMContentLoaded', initRecentlyViewed);
  document.addEventListener('shopify:section:load', initRecentlyViewed);
})();